angular.module( 'mtic' ).service( 'cordovaMessenger', function (
  $log,
  $q,
  $timeout,
  EventManager,
  LocaleService,
  PlatformService
) {

  function getNextMessageId () {
    return ++lastMessageId;
  }

  function handleResponse (data) {
    var responseDeferred = pendingResponses[data.messageId];
    var responseTypeName = responseTypeNameExtractor.exec(data.messageType)[1];
    var responseType = responseTypes[responseTypeName];
    if (!responseDeferred) {
      throw new Error('could not find a deferred object for response!');
    }
    if (responseDeferred === "TIMED_OUT") {
      $log.warn('received app response, but it has already timed out!', data);
      return;
    }
    if (!responseType) {
      throw new Error('could not find a response type for response!');
    }
    try {
      responseDeferred.resolve(responseType.handleResponse(data));
    } catch (err) {
      responseDeferred.reject({
        err: err, data: data
      });
    }
  }

  function onMessage (event) {
    if (!event.origin || !event.data) {
      return;
    }

    if (responseTypeNameExtractor.test(event.data.messageType)) {
      // this message is a response to a request sent by requestResponse
      try {
        handleResponse(event.data);
        return;
      } catch (err) {
        $log.error(err, event);
        throw err;
      }
    }

    var handler = messageHandlers[event.data.messageType];
    if (typeof handler === "function") {
      handler(event.data);
    } else {
      $log.warn('no handler for post message messageType, event will be ignored', event);
    }
  }
  window.addEventListener('message', onMessage, {
    capture: false,
    passive: true
  });

  var cordovaOrigin = 'file://';
  var eventManager = new EventManager('cordovaMessenger');
  var lastMessageId = 0; // do not access this directly: use getNextMessageId() instead
  var responseTypeNameExtractor = /^response:(.*)$/;
  var pendingResponses = {};

  /*
   * Put handlers here for events that are sent from cordova in response to a
   * request from this.requestResponse. The handleResponse function will be
   * passed the message object sent from cordova as its first argument, and its
   * return value will be used to resolve the promise that was returned from
   * this.requestResponse
   */
  var responseTypes = {
    requestNativeAdalLogin: {
      handleResponse: function (eventData) {
        eventManager.broadcast('start-login-attempt');
        var srcProfile = _.assignIn({}, eventData.payload);
        return {
          profile: {
            _srcProfile: srcProfile,
            exp: moment(srcProfile.expiresOn).unix(),
            name: srcProfile.userInfo.displayableId,
            oid: srcProfile.userInfo.userId,
            unique_name: srcProfile.userInfo.uniqueId,
            ver: '1.0'
          }
        };
      }
    },
    requestNativeAdalLogout: {
      handleResponse: function (eventData) {
        $log.debug('response:requestNativeAdalLogout', eventData);
        return eventData;
      },
      timeout: {
        after: 500,
        timeoutResult: 1
      }
    },
    requestSamlLogin: {
      handleResponse: function (eventData) {
        $log.debug('response:requestSamlLogin', eventData);
        return eventData;
      }
    }
  }

  /*
   * Put handlers here for events that originate from cordova. The handler
   * will be passed the message object sent from cordova as its first argument
   */
  var messageHandlers = {
    nativePause: function () {
      eventManager.broadcast('focusout:end')
      LocaleService.idleFocus = false;
      eventManager.broadcast('mouse:keyboard:active', {idleInput: LocaleService.idleInput, away: LocaleService.isAway});
    },
    nativeResign: function () {
      eventManager.broadcast('focusout:end')
      LocaleService.idleFocus = false;
      eventManager.broadcast('mouse:keyboard:active', {idleInput: LocaleService.idleInput, away: LocaleService.isAway});
    },
    nativeResume: function () {
      eventManager.broadcast('focusout:start')
      LocaleService.idleFocus = true;
    },
    appautologin: function () {
      eventManager.broadcast('app:auto:login')
    }
  };

  this.getAvailableResponseTypes = function () {
    return Object.keys(responseTypes);
  }

  /*
   * Send a one-way message to cordova
   */
  this.postToCordova = function postToCordova (type, payload) {
    $log.log('post to cordova : ', type, payload)
    if (!window.webkit || !window.webkit.messageHandlers.cordova_iab) {
      window.parent.postMessage({
        messageId: null,
        messageType: type,
        payload: payload
      }, "*");
    } else {
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        messageId: null,
        messageType: type,
        payload: payload
      }))
    }
  }

  /*
   * Send a message to cordova requesting a response. Returns a promise that
   * will resolve with the value return by a handleResponse function from
   * responseTypes
   */
  this.requestResponse = function requestResponse (responseType, payload) {
    var deferred, messageId;
    if (!responseTypes[responseType]) {
      $q.reject('unknown responseType: "' + responseType + '"');
    }
    deferred = $q.defer();
    messageId = getNextMessageId();
    pendingResponses[messageId] = deferred;
    if (!window.webkit || !window.webkit.messageHandlers.cordova_iab) {
      window.parent.postMessage({
        messageId: messageId,
        messageType: responseType,
        payload: payload
      }, "*");
    } else {
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        messageId: messageId,
        messageType: responseType,
        payload: payload
      }))
    }
    var timeoutSpec = responseTypes[responseType].timeout
    if (timeoutSpec) {
      $timeout(function () {
        $log.warn('request timed out!', {
          responseType: responseType,
          payload: payload,
          messageId: messageId
        });
        pendingResponses[messageId] = "TIMED_OUT";
        deferred.resolve(timeoutSpec.timeoutResult);
      }, timeoutSpec.after)
    }
    return deferred.promise;
  };

  if (!PlatformService.isApp) {
    this.postToCordova = this.requestResponse = function cordovaRejection () {
      var msg = 'this function cannot be used without Cordova!';
      return $q.reject(new Error(msg));
    }
  }
})
